import React from 'react';
import { MilestoneDeliveryButton, MilestoneApproveButton, MilestoneRejectButton } from './MilestoneDeliveryButton';

export const MilestoneActionsField = ({ record, onSuccess }) => (
  <div style={{ display: 'flex', alignItems: 'center' }}>
    <MilestoneDeliveryButton record={record} onSuccess={onSuccess} />
    <MilestoneApproveButton record={record} onSuccess={onSuccess} />
    <MilestoneRejectButton record={record} onSuccess={onSuccess} />
  </div>
);

export default MilestoneActionsField;
